// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"473":"main_page","923":"old_main_page"}[chunkId] + "." + {"473":"75ba8c61","923":"6debd3a1"}[chunkId] + ".chunk.css";
};